import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { Navigation, TabView } from '@swf/poker';

import { NAVIGATION_TABS } from '../../constants';
import { usePokerCashGamesWidget } from '../../model';
import type { NavigationTabTypes } from '../../types';
import { GameType, NavigationTabs } from '../../types';

import GameView from './GameView/GameView';
import { TXTCLI_Not_available_at_this_timeX, TXTCLI_View } from './SimpleView.messages.json';
import styles from './SimpleView.scss';

const SimpleView: React.FC = () => {
  const {
    widgetConfig: { game_variations: availableGameTypes = [] },
    widgetDispatch
  } = usePokerCashGamesWidget();
  const { tab } = useSelector(select.cms.getUrlParams);
  const currentTab =
    availableGameTypes.find((gameType) => gameType.toLowerCase() === tab) || availableGameTypes[0];
  const [selectedTab, setSelectedTab] = useState<NavigationTabTypes>(currentTab);
  const navigationTabs = NAVIGATION_TABS.filter((navTab) =>
    availableGameTypes.includes(navTab.tabName)
  );

  useEffect(() => {
    widgetDispatch.setActiveSimpleGameType(GameType[selectedTab]);
  }, [selectedTab, widgetDispatch]);

  const handleTabSelected = (page: NavigationTabTypes) => {
    setSelectedTab(page);
  };

  if (!availableGameTypes.length) {
    return (
      <div className={styles.featureUnavailable}>
        <Translation {...TXTCLI_View} tagName="span" />{' '}
        <Translation {...TXTCLI_Not_available_at_this_timeX} tagName="span" />
      </div>
    );
  }

  return (
    <div data-testid="simple-view">
      <Navigation
        navTabs={navigationTabs}
        selectedTab={selectedTab}
        onSelectTab={handleTabSelected}
      />
      <TabView activeTab={selectedTab}>
        <TabView.Tab name={NavigationTabs.HOLDEM}>
          <GameView gameVariation={NavigationTabs.HOLDEM} />
        </TabView.Tab>
        <TabView.Tab name={NavigationTabs.OMAHA}>
          <GameView gameVariation={NavigationTabs.OMAHA} />
        </TabView.Tab>
      </TabView>
    </div>
  );
};

export default SimpleView;
